import { AccountMultiplePlusOutlineIcon } from './AccountMultiplePlusOutlineIcon';

/**
 * author: Google
 * id AFF0AB6B-616A-4C18-8E28-EE8067224EED
 * name account-multiple-plus-outline
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-multiple-plus-outline.svg
 * tags
 * - Account / User 
 */
export const UsersAddOutlineIcon = AccountMultiplePlusOutlineIcon;
export default UsersAddOutlineIcon